import type { InvoiceTypeString } from "@/lib/constants/invoice-type";
import { useTenant } from "@/providers/session";
import { useGetAllInvoices } from "@/queries/invoices/get-all";
import { useMemo } from "react";

const SHOW_IF_CREATED_BEFORE_DATE = new Date("2025-11-13");

export const useDebtorsWarning = (type: InvoiceTypeString) => {
  const { companyCreatedAt } = useTenant();

  const isReceivableType = useMemo(() => type === "receivable", [type]);

  const isInDateRange = useMemo(() => {
    return (
      !!companyCreatedAt &&
      new Date(companyCreatedAt) < SHOW_IF_CREATED_BEFORE_DATE
    );
  }, [companyCreatedAt]);

  const { data: anyReceivableInvoice, loading: isLoadingReceivableInvoices } =
    useGetAllInvoices({
      enabled: isInDateRange && isReceivableType,
      query: {
        type: {
          op: "eq",
          value: "receivable",
        },
      },
      limit: 1,
    });

  const hasNoReceivableInvoices = useMemo(() => {
    return !isLoadingReceivableInvoices && anyReceivableInvoice.length === 0;
  }, [anyReceivableInvoice, isLoadingReceivableInvoices]);

  const showDebtorsWarning = useMemo(() => {
    return isInDateRange && isReceivableType && hasNoReceivableInvoices;
  }, [isInDateRange, isReceivableType, hasNoReceivableInvoices]);

  return { showDebtorsWarning };
};
